<template>
    <div>
        <div class="text-small text-gray pb-8">
            <a href="/admin">Admin</a> > Users
        </div>

        <d-table ref="table" :data="users" :show-detail-icon="false" :loading="loadingUsers" paginated backend-pagination detailed :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
            <template #action-buttons>
                <h2 class=" text-primary-500 mb-0">
                    Users
                </h2>
            </template>

            <template #action-buttons-right>
                <d-checkbox v-model="showInactive" class="pr-5">
                  Show Inactive
                </d-checkbox>
              
                <d-dropdown trap-focus>
                    <d-icon slot="activator" icon="download" class="text-black mr-5 p-2 bg-transparent" size="lg" />
                    <div style="width:300px" class="py-3 px-5">
                        <d-field label="Has User Ever Logged in*" :required="true">
                            <d-select v-model="exportFilter.isLastLoginNull">
                                <option value="false">
                                    Yes
                                </option>
                                <option value="true">
                                    No
                                </option>
                                <option value="">
                                    Either
                                </option>
                            </d-select>
                        </d-field>

                        

                        <div v-if="exportFilter.isLastLoginNull !== 'true' && exportFilter.isLastLoginNull !== ''">
                            <d-field>
                                <d-checkbox v-model="exportFilter.isAnyDate" @input="setAnyDateLoginDates">Any Last Logon Date</d-checkbox>
                            </d-field>

                            <div v-if="!exportFilter.isAnyDate">
                                <d-field label="From Last Login Date*" :required="true">
                                    <d-datepicker v-model="exportFilter.lastLoginFromDate" icon="calendar" expanded />
                                </d-field>
                                <d-field label="To Last Login Date*" :required="true">
                                    <d-datepicker v-model="exportFilter.lastLoginToDate" icon="calendar" expanded />
                                </d-field>
                            </div>
                        </div>

                            <d-field label="Status Type*" :required="true">
                                <d-select v-model="exportFilter.isUserAccountActive">
                                    <option value="Active">
                                        Active
                                    </option>
                                    <option value="Inactive">
                                        Inactive
                                    </option>
                                    <option value="Withdrawn">
                                        Withdrawn
                                    </option>
                                    <option value="">
                                        Any
                                    </option>
                                </d-select>
                            </d-field>

                            <d-btn color="danger" type="submit" @click="handleUserExportSubmit()">
                                Export to Excel
                            </d-btn>
                        </div>
                </d-dropdown>
                <filter-dropdown v-model="filter" />
                <d-btn class="" @click="launchUsersModal()">
                    + New User
                </d-btn>
            </template>

            <template slot-scope="{row}">
                <d-table-column class="chevron-cell" width="10">
                    <a v-if="userIsMentorMentee(row.roles)" role="button" @click.stop="toggle(row)">
                        <d-icon icon="chevron-right" class="ease-in-out" :class="{'is-expanded': isVisibleDetailRow(row) }" />
                    </a>
                </d-table-column>
                <d-table-column field="lastName" label="Name" sortable>
                    <a class="underline" :href="'/assignments/status/' + row.firstName + '-' + row.lastName + '/' + row.id" target="_blank">{{ row.firstName }} {{ row.lastName }}</a>                   
                </d-table-column>
                <d-table-column field="email" label="System Email" sortable>
                    {{ row.systemEmail }}
                </d-table-column>
                <d-table-column field="lastLoginDate" label="Last Login" sortable>
                    <span v-if="row.lastLoginDate">
                        {{ row.lastLoginDate | formatShortDate }}
                    </span>
                    <span v-else>
                        Never
                    </span>
                </d-table-column>
                <d-table-column field="communities" label="Community" sortable>
                    {{ row.communities }}
                </d-table-column>
                <d-table-column field="roles" label="Role(s)" sortable>
                    {{ row.roles.join(', ') }}
                </d-table-column>
                <d-table-column field="status" label="Status">
                    {{ row.status }}
                </d-table-column>
                <d-table-column label="More Info">
                    <a class="text-secondary-500 underline" :href="'/users/profile/' + row.id">Edit All Data</a>
                </d-table-column>
                <d-table-column label=" ">
                    <div class="flex justify-end items-center">
                        <d-icon icon="envelope" class="cursor-pointer w-5" @click.native="launchNotificationsModal(row)" />
                        <d-icon icon="edit" class="cursor-pointer text-green-500 ml-4 w-5" @click.native="launchEditUsersModal(row)" />
                        <d-icon icon="trash" class="cursor-pointer text-red-500 ml-2 w-5" @click.native="deleteUser(row)" />
                    </div>
                </d-table-column>
            </template>
            <template slot="detail" slot-scope="props">
                <mentor-mentee-tabbed-page :user="props.row" />
            </template>
        </d-table>
    </div>
</template>

<script>
  import axios from 'axios';
  import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';
    import UserModal from './components/UserModal.vue';
    import dayjs from 'dayjs';

  export default {
    parent: true,

    data: () => ({
      users: [],
      rotateChevron: '',
      loadingUsers: false,
      total: 0,
      filter: '',
      showInactive: false,
      pagination: {
       page: 1,
       pageSize: 50,
       sortField: 'LastName',
       sortOrder: 'asc',
        },
        exportFilter: {
            isUserAccountActive: '',
            lastLoginFromDate: '01/01/2000',
            lastLoginToDate: '12/31/2050',
            isLastLoginNull: '',
            isAnyDate: true,
        },
    }),

    watch: {
      pagination: {
        handler() {
          this.getUsersPaged();
        },
        deep: true,
      },
      filter() {
        this.getUsersPaged();
      },
      showInactive() {
        this.getUsersPaged();
      }
    },

    mounted() {
      this.getUsersPaged();
    },

    methods: {
      userIsMentorMentee(roles) {
        return (roles.includes('Mentor') || roles.includes('Mentee') || roles.includes('Consultant'));
      },
      async getUsersPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `showInactive=${this.showInactive}`].join('&');
        this.loadingUsers = true;
        const { data } = await axios.get(`/api/admin/users/paged?${params}`);
        this.users = data.resultItems;
          this.total = data.totalRecords;
        this.loadingUsers = false;
      },

        async setAnyDateLoginDates() {
            if (this.exportFilter.isAnyDate) {
                this.exportFilter.lastLoginFromDate = '01/01/2000';
                this.exportFilter.lastLoginToDate = '12/01/2050';
            }
            else {
                this.exportFilter.lastLoginFromDate = dayjs(new Date()).format('MM/DD/YYYY');
                this.exportFilter.lastLoginToDate = dayjs(new Date()).format('MM/DD/YYYY');
            }
        },

      launchUsersModal() {
        this.$modal.open({
          parent: this,
          component: UserModal,
          hasModalCard: true,
          events: {
            getUsersPaged: () => this.getUsersPaged(),
          },

        });
      },

      launchEditUsersModal(user) {
        this.$modal.open({
          parent: this,
          component: UserModal,
          hasModalCard: true,
          props: {
            user,
          },
          events: {
            getUsersPaged: () => this.getUsersPaged(),
          },
        });
      },

      launchNotificationsModal(user) {
        this.$modal.open({
          parent: this,
          component: ViewNotificationModal,
          hasModalCard: true,
          props: {
            entityId: user.id,
            type: 'user',
            name: user.fullName,
          },
        });
      },

      async deleteUser(user) {
        this.$dialog.confirm({
          title: 'Deleting User',
          message: `Are you sure you want to <b>delete</b> ${user.firstName} ${user.lastName}? This action cannot be undone.`,
          confirmText: 'Delete User',
          confirmColor: 'red-500',
          onConfirm: async () => {
            await axios.delete(`/api/admin/users/${user.id}`);
            this.getUsersPaged();
            this.$toast.success('User deleted!');
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

      toggle(row) {
        this.$refs.table.toggleDetails(row);
      },

      isVisibleDetailRow(obj) {
        const index = this.$refs.table.handleDetailKey(obj);
        const result = this.$refs.table.visibleDetailRows.indexOf(index) >= 0;
        return result;
      },

      async handleUserExportSubmit() {
          const params = [`isUserAccountActive=${this.exportFilter.isUserAccountActive}`,
              `lastLoginFromDate=${dayjs(this.exportFilter.lastLoginFromDate).format('MM/DD/YYYY')}`,
              `lastLoginToDate=${dayjs(this.exportFilter.lastLoginToDate).format('MM/DD/YYYY')}`,
              `isLastLoginNull=${this.exportFilter.isLastLoginNull}`].join('&');
        this.fetchingReport = true;
        try {
          const { data } = await axios.get(`/api/admin/user-export?${params}`, {
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `UserReport_${dayjs(new Date()).format('MM-DD-YYYY')}.xlsx`);
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          this.$toast.error('Could not find any items due in the range you specified, try expanding the date range');
        } finally {
          this.fetchingReport = false;
        }
      },
    },
  };
</script>
